import {binderActionTypes as types} from '../constants';

export function requestInitialBinderData(currentUserId) {
  return {type: types.REQUEST_INITIAL_BINDER_DATA, currentUserId};
}


export function setEnabledFilters(payload) {
  return {type: types.SET_ENABLED_FILTERS, payload};
}

export function unloadBinderData() {
  return {type: types.UNLOAD_BINDER_DATA};
}
